// in src/restricted.js
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { batchActions } from "redux-batched-actions";
import Preloader from './Preloader';
import { abortRequest } from '../utility';

import orm from "../models";
import {
  create,
  upsert,
  remove,
  addto,
  removefrom,
  task_request,
  noop
} from "../actions";

const batchProps = {
  create,
  upsert,
  remove,
  addto,
  removefrom,
  task_request,
  noop
};

const mapStateToProps = (state, ownProps) => ({
  Session: orm.session(state.orm)
});
const mapDispatchToProps = {
  batch: batchActions,
  create,
  upsert,
  remove,
  addto,
  removefrom,
  task_request,
  noop
};


/**
 * Higher-order component (HOC) to wrap restricted pages
 */
export const AuthHOC = BaseComponent => {
  class HOC extends Component {
    constructor(props) {
      super(props);
      this.state = {
        checkLogin: null
      };
    }
    componentDidMount() {
      if (this.props.history.location.pathname === '/login') {
        localStorage.removeItem('id_token');
        this.setState({ checkLogin: true });
      }
      this.props.history.listen((location) => {
        if(this.props.Session.Settings.withId(0).calls) {
          abortRequest();
        }
      })
    }
    componentWillMount() {
      // console.log('Current props: ', this.props);
      this.checkAuthentication(this.props);
    }
    componentWillReceiveProps(nextProps) {
      // console.log('Current props: ', this.props);
      // console.log('Next props: ', nextProps);
      const loginUrl = "/login";
      if (
        nextProps.location !== this.props.location ||
        nextProps.location.pathname === loginUrl
      ) {
        this.checkAuthentication(nextProps);
      } else {
        // this.setState({ checkLogin: true });
      }
    }
    checkAuthentication(params) {
      const { Session, history } = params;
      const token = localStorage.getItem('id_token');
      const authenticated = Session.Settings.withId(0).token ? true : false;
      if (token && !authenticated) {
        if (history.location.pathname === '/login') {
          localStorage.removeItem('id_login');
          this.setState({ checkLogin: true });
        } else {
          this.reLogin(token, history);
        }
      } else {
        const loginUrl = "/login";
        if (!authenticated && history.location.pathname !== loginUrl) {
          // console.log('Redirect to login');
          history.replace({ pathname: "/login" });
        } else if (authenticated && history.location.pathname === loginUrl) {
          history.replace({ pathname: "/dashboard" });
        }
        this.setState({ checkLogin: true });
      }
      // console.log(
      //   "authenticated",
      //   authenticated,
      //   "pathname",
      //   history.location.pathname
      // );
    }
    async reLogin(token, history) {
      await this.props.task_request({
        login: true,
        action: "login",
        payload: { id_token: token },
        success: result => {
          if (!result.id_token) {
            localStorage.removeItem('id_token');
            this.setState({ checkLogin: true });
            history.replace({ pathname: "/login" });
          }

          return batchActions([
            this.props.upsert({
              model: "Settings",
              payload: { token: result.id_token, ...result.config.info, id: 0 }
            }),
            ...result.config.folders.map(item =>
              this.props.upsert({
                model: "RX_Folder",
                payload: { ...item, collapsed: true }
              })
            ),
            ...result.config.boards.map(item =>
              this.props.upsert({ model: "RX_Board", payload: { ...item } })
            ),
            ...result.config.boards.map(item =>
              this.props.addto({
                model: "Settings",
                payload: { item: "boards", value: item.id }
              })
            ),
            ...result.config.groups.map(item =>
              this.props.upsert({ model: "RX_Group", payload: { ...item } })
            ),
            ...result.config.groups.map(item =>
              this.props.addto({
                model: "Settings",
                payload: { item: "groups", value: item.id }
              })
            )
          ]);
        }
      });
      this.setState({ checkLogin: true });
    }
    render() {
      if (this.state.checkLogin === null) {
        return <Preloader />
      }
      return <BaseComponent {...this.props} batch={batchProps} />;
    }
  }
  return withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(HOC)
  );
};

// export const unrestricted = BaseComponent => {
//   class HOC extends Component {
//     componentWillMount() {
//       // console.log('Current props: ', this.props);
//       this.checkLocation(this.props);
//     }
//     componentWillReceiveProps(nextProps) {
//       // console.log('Current props: ', this.props);
//       // console.log('Next props: ', nextProps);
//       if (nextProps.location !== this.props.location) {
//         this.checkLocation(nextProps);
//       }
//     }
//     checkLocation(params) {
//       const { Session, history } = params;
//       const authenticated = Session.Settings.withId(0).token ? true : false;
//       console.log("history", history);
//       if (!authenticated) {
//         history.replace({ pathname: "/login" });
//       } else if (history.location.pathname === "/login") {
//         history.replace({ pathname: "/dashboard" });
//       }
//     }
//     render() {
//       return <BaseComponent {...this.props} />;
//     }
//   }
//   return withRouter(connect(mapStateToProps, mapDispatchToProps)(HOC));
// };



// WEBPACK FOOTER //
// ./src/components/AuthHOC.js